/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Itemseyebrow1Inputs */

const id_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kepemilikan katalog`)
};

const ms_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemilikan katalog`)
};

const da_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katalog-ejerskab`)
};

const de_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katalogbesitz`)
};

const en_us2_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catalog ownership`)
};

const es_es2_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propiedad de catálogo`)
};

const es_mx2_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propiedad de catálogo`)
};

const fil_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagmamay-ari ng catalog`)
};

const fr_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propriété du catalogue`)
};

const it_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proprietà catalogo`)
};

const hu_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katalógus tulajdonjog`)
};

const nl_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catalogus eigendom`)
};

const no_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katalogeierskap`)
};

const pl_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Własność katalogu`)
};

const pt_br2_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propriedade do catálogo`)
};

const pt_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propriedade do catálogo`)
};

const ro_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proprietate catalog`)
};

const fi_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katalogin omistus`)
};

const sv_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katalogägande`)
};

const vi_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quyền sở hữu danh mục`)
};

const tr_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katalog sahipliği`)
};

const cs_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vlastnictví katalogu`)
};

const bg_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Собственост на каталог`)
};

const ru_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Владение каталогом`)
};

const uk_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Власність каталогу`)
};

const ar_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملكية الكتالوج`)
};

const hi_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैटलॉग स्वामित्व`)
};

const th_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ความเป็นเจ้าของแค็ตตาล็อก`)
};

const ja_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カタログ所有権`)
};

const zh_cn2_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目录拥有权`)
};

const zh_hant1_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目錄擁有權`)
};

const ko_sandboxes_itemseyebrow1 = /** @type {(inputs: Sandboxes_Itemseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`카탈로그 소유권`)
};

/**
* | output |
* | --- |
* | "Catalog ownership" |
*
* @param {Sandboxes_Itemseyebrow1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_itemseyebrow1 = /** @type {((inputs?: Sandboxes_Itemseyebrow1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Itemseyebrow1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_itemseyebrow1(inputs)
	if (locale === "ms") return ms_sandboxes_itemseyebrow1(inputs)
	if (locale === "da") return da_sandboxes_itemseyebrow1(inputs)
	if (locale === "de") return de_sandboxes_itemseyebrow1(inputs)
	if (locale === "en-US") return en_us2_sandboxes_itemseyebrow1(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_itemseyebrow1(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_itemseyebrow1(inputs)
	if (locale === "fil") return fil_sandboxes_itemseyebrow1(inputs)
	if (locale === "fr") return fr_sandboxes_itemseyebrow1(inputs)
	if (locale === "it") return it_sandboxes_itemseyebrow1(inputs)
	if (locale === "hu") return hu_sandboxes_itemseyebrow1(inputs)
	if (locale === "nl") return nl_sandboxes_itemseyebrow1(inputs)
	if (locale === "no") return no_sandboxes_itemseyebrow1(inputs)
	if (locale === "pl") return pl_sandboxes_itemseyebrow1(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_itemseyebrow1(inputs)
	if (locale === "pt") return pt_sandboxes_itemseyebrow1(inputs)
	if (locale === "ro") return ro_sandboxes_itemseyebrow1(inputs)
	if (locale === "fi") return fi_sandboxes_itemseyebrow1(inputs)
	if (locale === "sv") return sv_sandboxes_itemseyebrow1(inputs)
	if (locale === "vi") return vi_sandboxes_itemseyebrow1(inputs)
	if (locale === "tr") return tr_sandboxes_itemseyebrow1(inputs)
	if (locale === "cs") return cs_sandboxes_itemseyebrow1(inputs)
	if (locale === "bg") return bg_sandboxes_itemseyebrow1(inputs)
	if (locale === "ru") return ru_sandboxes_itemseyebrow1(inputs)
	if (locale === "uk") return uk_sandboxes_itemseyebrow1(inputs)
	if (locale === "ar") return ar_sandboxes_itemseyebrow1(inputs)
	if (locale === "hi") return hi_sandboxes_itemseyebrow1(inputs)
	if (locale === "th") return th_sandboxes_itemseyebrow1(inputs)
	if (locale === "ja") return ja_sandboxes_itemseyebrow1(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_itemseyebrow1(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_itemseyebrow1(inputs)
	return ko_sandboxes_itemseyebrow1(inputs)
});
export { sandboxes_itemseyebrow1 as "sandboxes.itemsEyebrow" }